import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { reduxForm } from 'redux-form';
import Button from '../../components/elements/Button/Button';
import ButtonFileInput from '../../components/elements/ButtonFileInput/ButtonFileInput';
import ButtonLink from '../../components/elements/ButtonLink';
import LoadingBars from '../../components/elements/LoadingBars';
import styles from './styles.scoped.css';

export function Component({ change = () => {}, handleSubmit = () => {} }) {
  const [error, setError] = useState({});
  const [file, setFile] = useState({});

  const { isLoadingUploadUpdatePriceSubUser } = useSelector((s) => s.prices);
  const fileUrl =
    'https://storage.googleapis.com/fin-map-images-public-stage/templates/template%20HET%20Sub%20Pangkalan.csv';

  const clearErrors = () => {
    setError({});
  };

  let bodyFormData = new FormData();

  const handleRemoveFormData = () => {
    setFile({});
  };

  const handleChangeFile = (name, val) => {
    const modPayload = { file: val };
    Object.keys(modPayload).forEach((val) => {
      bodyFormData.append(name, modPayload[val]);
    });
    setFile(bodyFormData);
  };

  useEffect(() => {
    change('file', file);
  }, [file]);

  const handleIsValid = () => {
    if (
      file instanceof FormData &&
      Object.keys(error).length === 0 &&
      isLoadingUploadUpdatePriceSubUser !== true
    ) {
      return false;
    }
    return true;
  };

  // useEffect(() => {
  //   if(messageUploadUpdatePrice?.includes(' is required') && !isLoadingUploadUpdatePriceSubUser){
  //     setError({ file: { message: 'Belum memasukkan file' } });
  //   }
  // }, [isLoadingUploadUpdatePriceSubUser]);

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className={styles['top-content-upload-reg-container']}>
          <div
            className={styles['left-content-upload-reg']}
            style={{ maxWidth: '60%' }}
          >
            <h4>
              Pilih file dengan format .CSV untuk ubah harga dalam jumlah banyak
            </h4>
            <br />
            <br />
          </div>
          <div className={styles['right-content-upload-reg']}>
            <img
              className={styles['illustration-upload']}
              src="assets/illu-registrasi-pangkalan.svg"
            />
          </div>
        </div>
        <div className={styles['row-between']}>
          <ButtonFileInput
            clearErrors={clearErrors}
            deleteFile={handleRemoveFormData}
            errors={error.file}
            extensionAllowed={['csv']}
            handleChangeFile={handleChangeFile}
            name="file"
            noBase64={true}
            outlined={true}
            setError={setError}
            sizeValidation={{ kbsize: 20000 }}
          >
            Pilih File
          </ButtonFileInput>
          {isLoadingUploadUpdatePriceSubUser && (
            <div style={{ marginLeft: '10px' }}>
              <LoadingBars size={1} />
            </div>
          )}
        </div>
        <hr />
        <div>
          <h5>Cara Tambah Sekaligus:</h5>
          <ol className={styles['step-upload-xlsx-regist-bulk']}>
            <li style={{ marginTop: '1rem' }}>
              Unduh file Excel{' '}
              <a
                download
                href={fileUrl}
                style={{ color: '#5E811E', cursor: 'pointer', fontWeight: 700 }}
              >
                di sini.
              </a>
            </li>
            <li style={{ marginTop: '1rem' }}>Atur harga eceran tertinggi.</li>
            <li style={{ marginTop: '1rem' }}>
              Unggah kembali file yang sudah diisi.
            </li>
          </ol>
        </div>
        <br />
        <div className={styles['action-btn-container']}>
          <ButtonLink
            className={styles['action-btn-back']}
            outlined={true}
            to={'/price?tab=subpangkalan'}
          >
            Kembali
          </ButtonLink>
          <Button
            className={styles['action-btn-continue']}
            disabled={handleIsValid()}
            type="submit"
          >
            Unggah
          </Button>
        </div>
      </form>
    </>
  );
}

Component.propTypes = {
  change: PropTypes.func,
  handleSubmit: PropTypes.func,
};

export default reduxForm({
  form: 'bulk-update-price-sub-user',
  initialValues: {
    file: [],
  },
})(Component);
